/* global swal angular */

import './style.less';

export default function($location, $log, $stateParams, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.callback = activate;

  vm.profile_uid = $stateParams.id;

  vm.formData = {
    questions: {},
    text_area: []
  };

  switch ($stateParams.tab) {
    case 'users':
      vm.activeTab = 1;
      break;
    default:
      vm.activeTab = 0;
  }

  vm.updateSearch = tab => $location.search('tab', tab);

  vm.infoClosed = () => {
    const event = new CustomEvent('info-closed');

    vm.tabContainer.dispatchEvent(event);
  };

  vm.onInitContainer = () => {
    vm.tabContainer = document.getElementById('activityTabs');
  };

  function activate() {
    $log.debug('ADMIN ACTIVITY ACTIVATED');
    vm.loaded = false;
    vm.error = {};

    if (!$stateParams.activity_id) return (vm.loaded = true);

    ApiClass.activitiesIdGet({ id: $stateParams.activity_id, profile_uid: $stateParams.id, manage: true })
      .then(({ data: { item: activity } }) => {
        $log.debug('ADMIN ACTIVITY DATA ', activity);

        if (!activity.text_area) activity.text_area = [];

        vm.formData = angular.copy(activity);
        vm.activity = activity;
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/author/activities/edit/controller.js